import React, { Component, Fragment } from 'react';
import LinearWithValueLabel from './LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';
import {properties} from '../resources/properties.js';

export default class LoadingModal extends Component {
  render() {
    const { style, text, classNameText, includeLinearProgress, isFoto, series } = this.props;
    const intervalTimeAux = isFoto === true ? properties.WAITING_TIME_PDF_PNOA : properties.WAITING_TIME_PDF_MTN;
    const intervalTime = series > 1 ? intervalTimeAux*series : intervalTimeAux;
    const textSplitted = text.split('\n').map((item, i) => {
      return <p key={i}>{item}</p>
    });
    return (<Fragment>
      <div className="loading_modal" style={{
        display: style
      }}></div>
      <div className="loader-circular-progress" style={{
        display: style,
        color: "white"
      }}>
        { text === "" ? <React.Fragment/> : <React.Fragment>
        <CircularProgress color={"inherit"} size={"7vh"} className={classNames("loader")}/>
        </React.Fragment> }

      </div>
      <div className="loader" style={{
        display: style,
        color: "white"
      }}>
        { text === ""  || !includeLinearProgress ? <React.Fragment/> : <React.Fragment>
        <LinearWithValueLabel intervalTime={intervalTime / 20} color={"inherit"} size={"7vh"} className={classNames("loader")} />
        </React.Fragment> }

      </div>
      <span className={classNameText}>{textSplitted}</span>
    </Fragment>);
  }
}
